import { CashFlow as _CashFlow } from '@models/API/trusts/cash-flow.model';
import { Lender as _Lender } from '@models/API/trusts/lender.model';
import { Operations as _Operations } from '@models/API/trusts/operations.model';
import { Storage as _Storage } from '@models/API/trusts/storage.model';

export namespace Trusts {
  export import Operations = _Operations;
  export import Lender = _Lender;
  export import CashFlow = _CashFlow;
  export import Storage = _Storage;

  export enum ChartName {
    AGING = 'AGING',
    AGING_SNAPSHOTS = 'AGING_SNAPSHOTS',
    COLLECTION = 'COLLECTION',
    ASSETS = 'ASSETS',
    OVERCOLLATERALIZATION = 'OVERCOLLATERALIZATION',
    BORROWING_BASE = 'BORROWING_BASE',
    UTILIZATION_TRAJECTORY = 'UTILIZATION_TRAJECTORY',
    ACCOUNT_BALANCE = 'ACCOUNT_BALANCE',
    CONCENTRATION = 'CONCENTRATION',
  }
}
